import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-loading',
  templateUrl: './global-loading.component.html',
  styleUrls: ['./global-loading.component.less'],
})
export class GlobalLoadingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
